The identifier for the `WebhookAttempt`.
